import { Component } from '@angular/core';
import { PanelModule } from 'primeng/panel';

@Component({
  selector: 'app-settings-general',
  template: `<p-panel header="General Settings"> Customizable options coming soon! </p-panel>`,
  standalone: true,
  imports: [PanelModule],
})
export class SettingsGeneralComponent {}
